var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"film"},[_c('mt-header',{attrs:{"title":"导航"}},[_c('router-link',{attrs:{"slot":"left","to":"/"},slot:"left"},[_c('mt-button',{attrs:{"icon":"back"}})],1)],1),_vm._v("\n\t222\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e1a06fb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/film.vue
// module id = null
// module chunks = 